import { render } from "./TabAddresses.vue?vue&type=template&id=4592b7cc"
import script from "./TabAddresses.vue?vue&type=script&lang=js"
export * from "./TabAddresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__